export default __webpack_public_path__ + "static/media/walletconnect.0aecac1d.png";